// import React, { useEffect, useState } from 'react';
// import { Card } from '../../../../Components/ui/card';
// import { Label } from '../../../../Components/ui/label';
// import { Input } from '../../../../Components/ui/input';
// import { MultiSelectFromCountry } from '../../../../Components/ui/multi-select-from-country';
// import { SingleSelectToCountry } from '../../../../Components/ui/single-select-to-country';
// import { useCampaignContext } from '../CampaignContext';
// import axios from 'axios';
// import { RootState } from '@/src/State/store';
// import { useDispatch, useSelector } from 'react-redux';
// import { useCampaignValidators } from "../hooks/useCampaignValidators";
// import { CircularProgress } from "@mui/material";
// import { setSelectedFromCountryISOs } from "../../../../State/slices/AdvertiserAccountSlice";
// import { Switch } from "../../../../Components/ui/switch";
// import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from "../../../../Components/ui/tooltip";

// interface Country {
//   country_name: string;
//   country_code: string;
//   country_iso: string;
// }

// const CampaignNameCard: React.FC = () => {
//   const {
//     campaignName,
//     setCampaignName,
//     fromCountries,
//     setFromCountries,
//     toCountry,
//     setToCountry,
//     setFromCountryOptions,
//     FromCountryOptions,
//     setToCountryOptions,
//     ToCountryOptions,
//     setFromCountryISOs,
//     setFromCountryCodeMap,
//     setToCountryISOs,
//     setToCountryCodeMap,
//     setSelectedFromCountryCodes,
//     setSelectedToCountryISO,
//     setSelectedToCountryCode,
//     setWhatsappCountries,
//     setSmsCountries,
//     setChannelOptions,
//     campaignNameError,
//     fromCountryError,
//     toCountryError,
//     isSubmitAttempted,
//     toCountryISOs,
//     fromCountryISOs,
//     toCountryCodeMap,
//     fromCountryCodeMap,
//     updateCampaignId,
//     setCountries,
//     countries,
//     setReadonlyFromCountries,
//     fromCountryISOsFromAPI,
//     setReadonlyFromCountryOptions,
//     readonlyFromCountryOptions,
//     setTargetCountries,
//     toCountryISOFromAPI,
//     targetCountries,
//     setUpdateModeToCountryOptions,
//     updateModeToCountryOptions,
//     isUpdateMode,
//     whatsappData,
//     smsData,
//     setWhatsappData,
//     setSmsData,
//     selectedChannels,
//     setSelectedChannels,
//     whatsappCountries,
//     smsCountries,
//     setLoading,
//     isLoading,
//     setCampaignNames,
//     isViewMode,
//     draftNameError,
//     draftNames,
//     isDraftSubmitAttempted,
//     isTestMode,
//     setIsTestMode
//   } = useCampaignContext();

//   const selectedFromCountryISOs = useSelector((state: RootState) => state.advertiserAccount.selectedFromCountryISOs);
//   const dispatch = useDispatch();

//   // ✅ Add loading states
//   const [isLoadingCountries, setIsLoadingCountries] = useState(false);
//   const [countriesLoaded, setCountriesLoaded] = useState(false);
//   const [targetCountriesLoaded, setTargetCountriesLoaded] = useState(false);

//   const { validateCampaignName, validateFromCountry, validateToCountry, clearValidationErrors, validateDraftName } = useCampaignValidators();
//   const apiUrlAdvAcc = useSelector((state: RootState) => state.authentication.apiURL);
//   const workspaceId = useSelector((state: RootState) => state.authentication.workspace_id);


//   // Updates selected ISO + code list based on selected country names
//   const updateSelectedISOs = (countryNames: string[]) => {
//     const isoList = countryNames.map(name => fromCountryISOs[name]).filter(Boolean);
//     const codeList = isoList.map(iso => fromCountryCodeMap[iso]).filter(Boolean);

//     dispatch(setSelectedFromCountryISOs(isoList));
//     setSelectedFromCountryCodes(codeList);
//   };

//   // Updates To Country ISO and code based on name
//   const updateSelectedToCountry = (name: string | null) => {
//     if (!name) {
//       setSelectedToCountryISO(null);
//       setSelectedToCountryCode(null);
//       return;
//     }

//     const iso = toCountryISOs[name];
//     const code = iso ? toCountryCodeMap[iso] : null;

//     setSelectedToCountryISO(iso || null);
//     setSelectedToCountryCode(code || null);
//   };

//   // Smart cleanup function for when fromCountries change
//   const handleFromCountryChange = (selectedCountries: string[]) => {
//     if (selectedCountries.length === 0) {
//       setWhatsappCountries([]);
//       setSmsCountries([]);
//       setChannelOptions([]);
//       setWhatsappData([]);
//       setSmsData([]);
//       setSelectedChannels([]);
//       clearValidationErrors?.('whatsapp');
//       clearValidationErrors?.('sms');
//       return;
//     }

//     const currentWhatsappCountryNames = whatsappCountries.map(c => c.name);
//     const currentSmsCountryNames = smsCountries.map(c => c.name);

//     const whatsappCountriesToRemove = currentWhatsappCountryNames.filter(
//       countryName => !selectedCountries.some(selectedCountry => {
//         const whatsappCountryObj = whatsappCountries.find(wc => wc.name === countryName);
//         if (!whatsappCountryObj) return false;

//         const fromCountryISO = fromCountryISOs[selectedCountry];
//         return whatsappCountryObj.iso === fromCountryISO ||
//           countries.some(c => c.country_name === selectedCountry && c.country_iso === whatsappCountryObj.iso);
//       })
//     );

//     const smsCountriesToRemove = currentSmsCountryNames.filter(
//       countryName => !selectedCountries.some(selectedCountry => {
//         const smsCountryObj = smsCountries.find(sc => sc.name === countryName);
//         if (!smsCountryObj) return false;

//         const fromCountryISO = fromCountryISOs[selectedCountry];
//         return smsCountryObj.iso === fromCountryISO ||
//           countries.some(c => c.country_name === selectedCountry && c.country_iso === smsCountryObj.iso);
//       })
//     );

//     if (whatsappCountriesToRemove.length > 0) {
//       setWhatsappCountries(prev =>
//         prev.filter(country => !whatsappCountriesToRemove.includes(country.name))
//       );
//       setWhatsappData(prev =>
//         prev.filter(data => !whatsappCountriesToRemove.includes(data.country))
//       );
//       whatsappCountriesToRemove.forEach((_, index) => {
//         clearValidationErrors?.('whatsapp', index);
//       });
//     }

//     if (smsCountriesToRemove.length > 0) {
//       setSmsCountries(prev =>
//         prev.filter(country => !smsCountriesToRemove.includes(country.name))
//       );
//       setSmsData(prev =>
//         prev.filter(data => !smsCountriesToRemove.includes(data.country))
//       );
//       smsCountriesToRemove.forEach((_, index) => {
//         clearValidationErrors?.('sms', index);
//       });
//     }

//     const remainingWhatsappCountries = whatsappCountries.filter(
//       country => !whatsappCountriesToRemove.includes(country.name)
//     );
//     const remainingSmsCountries = smsCountries.filter(
//       country => !smsCountriesToRemove.includes(country.name)
//     );

//     const newChannelOptions: { label: string; value: string }[] = [];
//     const newSelectedChannels: string[] = [];

//     if (remainingWhatsappCountries.length > 0) {
//       newChannelOptions.push({ label: "WhatsApp", value: "whatsapp" });
//       if (selectedChannels.includes("whatsapp")) {
//         newSelectedChannels.push("whatsapp");
//       }
//     }

//     if (remainingSmsCountries.length > 0) {
//       newChannelOptions.push({ label: "SMS", value: "sms" });
//       if (selectedChannels.includes("sms")) {
//         newSelectedChannels.push("sms");
//       }
//     }

//     setChannelOptions(newChannelOptions);
//     setSelectedChannels(newSelectedChannels);
//   };

//   // ✅ Enhanced GetFromCountries with loading state
//   const GetFromCountries = async () => {
//     setIsLoadingCountries(true);
//     try {
//       const response = await axios.get(`${apiUrlAdvAcc}/GetFromCountries`);
//       if (response.data?.status === "Success" && Array.isArray(response.data.fromCountries)) {
//         const countries = response.data.fromCountries as Country[];
//         setCountries(countries);

//         const dropdownOptions = countries.map((c) => ({
//           label: c.country_name,
//           value: c.country_name,
//         }));

//         const isoMap = countries.reduce<{ [name: string]: string }>((acc, c) => {
//           acc[c.country_name] = c.country_iso;
//           return acc;
//         }, {});

//         const codeMap = countries.reduce<{ [iso: string]: string }>((acc, c) => {
//           acc[c.country_iso] = c.country_code;
//           return acc;
//         }, {});

//         setFromCountryOptions(dropdownOptions);
//         setFromCountryISOs(isoMap);
//         setFromCountryCodeMap(codeMap);
//         setCountriesLoaded(true);
//       }
//     } catch (err) {
//       console.error("Error fetching from countries:", err);
//     } finally {
//       setIsLoadingCountries(false);
//     }
//   };

//   // ✅ Enhanced GetToCountries with loading state
//   const GetToCountries = async () => {
//     try {
//       const response = await axios.get(`${apiUrlAdvAcc}/GetToCountries`);
//       if (response.data?.status === "Success" && Array.isArray(response.data.toCountries)) {
//         const countries = response.data.toCountries as Country[];
//         setTargetCountries(countries);

//         const dropdownOptions = countries.map((c) => ({
//           label: c.country_name,
//           value: c.country_name,
//         }));

//         const isoMap = countries.reduce<{ [name: string]: string }>((acc, c) => {
//           acc[c.country_name] = c.country_iso;
//           return acc;
//         }, {});

//         const codeMap = countries.reduce<{ [iso: string]: string }>((acc, c) => {
//           acc[c.country_iso] = c.country_code;
//           return acc;
//         }, {});

//         setToCountryOptions(dropdownOptions);
//         setToCountryISOs(isoMap);
//         setToCountryCodeMap(codeMap);
//         setTargetCountriesLoaded(true);
//       }
//     } catch (err) {
//       console.error("Error fetching to countries:", err);
//     }
//   };

//   // Call API to get WhatsApp & SMS available countries using ISO list
//   const GetAvailableCountries = async () => {
//     try {
//       const params = new URLSearchParams();
//       selectedFromCountryISOs.forEach((iso: any) => params.append("isos", iso));

//       const response = await axios.get(`${apiUrlAdvAcc}/GetAvailableWhatsappAndSmsCountries?${params.toString()}`);

//       if (response.data?.status === "Success") {
//         const countryResults = response.data.countries || [];
//         const whatsappList: { name: string; iso: string }[] = [];
//         const smsList: { name: string; iso: string }[] = [];
//         const newChannelOptions: { label: string; value: string }[] = [];

//         countryResults.forEach((entry: any) => {
//           const { channel_id, channel_name, countries = [] } = entry;

//           countries.forEach((country: { name: string; iso: string }) => {
//             const obj = { name: country.name, iso: country.iso };
//             if (channel_id === 1) whatsappList.push(obj);
//             if (channel_id === 2) smsList.push(obj);
//           });

//           newChannelOptions.push({
//             label: channel_name,
//             value: channel_name.toLowerCase()
//           });
//         });

//         setWhatsappCountries(whatsappList);
//         setSmsCountries(smsList);
//         setChannelOptions(newChannelOptions);
//       }
//     } catch (err) {
//       console.error("Error fetching available countries:", err);
//     }
//   };

//   const GetCampaignNames = async () => {
//     try {
//       const res = await axios.get(`${apiUrlAdvAcc}/GetAllCampaignNamesByWorkspaceID`, {
//         params: { workspaceId: workspaceId },
//       });

//       if (res.data.status === "Success" && Array.isArray(res.data.campaignNames)) {
//         const names = res.data.campaignNames;
//         setCampaignNames(names.map((name: string) => name.toLowerCase()));
//       } else {
//         setCampaignNames([]);
//       }
//     } catch (err) {
//       setCampaignNames([]);
//     }
//   };

//   // ✅ Initial data loading
//   useEffect(() => {
//     GetFromCountries();
//     GetToCountries();
//     GetCampaignNames();
//   }, []);

//   // ✅ Trigger available countries when both from and to countries are set
//   useEffect(() => {
//     if (fromCountries && toCountry) {
//       GetAvailableCountries();
//     }
//   }, [fromCountries, toCountry]);

//   // ✅ CRITICAL FIX: Process update mode data only when countries are loaded
//   useEffect(() => {
//     if (!updateCampaignId || !countriesLoaded || !fromCountryISOsFromAPI?.length) {
//       return;
//     }

//     console.log("🔄 Processing update mode countries - Countries loaded:", countriesLoaded);
//     console.log("🔄 fromCountryISOsFromAPI:", fromCountryISOsFromAPI);

//     const readonlyCountryNames: string[] = fromCountryISOsFromAPI
//       .map((iso) => {
//         const match = countries.find((c) => c.country_iso === iso);
//         return match?.country_name;
//       })
//       .filter((name): name is string => typeof name === "string");

//     console.log("🔄 Mapped country names:", readonlyCountryNames);

//     if (readonlyCountryNames.length > 0) {
//       setFromCountries(readonlyCountryNames);
//       setReadonlyFromCountries(readonlyCountryNames);

//       // Create readonly options for update mode
//       const readonlyOptions = countries.map((country) => ({
//         label: country.country_name,
//         value: country.country_name,
//         disabled: !readonlyCountryNames.includes(country.country_name),
//       }));

//       setReadonlyFromCountryOptions(readonlyOptions);

//       // Update ISO mappings for the selected countries
//       updateSelectedISOs(readonlyCountryNames);

//       console.log("✅ Update mode countries set successfully");
//     }
//   }, [updateCampaignId, countriesLoaded, fromCountryISOsFromAPI, countries]);

//   // ✅ Process update mode to country data
//   useEffect(() => {
//     if (!updateCampaignId || !toCountryISOFromAPI || !targetCountriesLoaded) {
//       return;
//     }

//     const matched = targetCountries.find(
//       (country) => country.country_iso === toCountryISOFromAPI
//     );

//     if (matched) {
//       const selected = {
//         label: matched.country_name,
//         value: matched.country_name,
//       };

//       setToCountry(matched.country_name);
//       setUpdateModeToCountryOptions([selected]);
//       updateSelectedToCountry(matched.country_name);

//       console.log("✅ Update mode to country set:", matched.country_name);
//     }
//   }, [updateCampaignId, toCountryISOFromAPI, targetCountriesLoaded, targetCountries]);

//   // Filter ToCountry dropdown to exclude selected From countries
//   const filteredToCountryOptions = ToCountryOptions.filter(
//     (toOption) => !fromCountries.includes(toOption.value)
//   );

//   // ✅ Show loading state while countries are being loaded in update/view mode
//   // if ((isUpdateMode || isViewMode) && (!countriesLoaded || !targetCountriesLoaded)) {
//   //   return (
//   //     <Card className="w-[600px] mt-[-10px] p-4 shadow-sm">
//   //       <div className="text-left">
//   //         <h3 className="text-base font-bold text-[#020617] text-left">
//   //           {isViewMode ? "View campaign" : "Edit campaign"}
//   //         </h3>
//   //         <div className="flex justify-center items-center h-32">
//   //           <CircularProgress size={24} />
//   //           <span className="ml-2 text-sm text-gray-600">Loading campaign data...</span>
//   //         </div>
//   //       </div>
//   //     </Card>
//   //   );
//   // }

//   const isTestModeDisabled = selectedChannels.length > 0 && (
//     !selectedChannels.includes("whatsapp") || selectedChannels.includes("sms")
//   );


//   useEffect(() => {
//     if (isTestModeDisabled) {
//       setIsTestMode(false);
//     }
//   }, [isTestModeDisabled]);


//   return (
//     <Card className="w-[600px] mt-[-10px] p-4 shadow-sm">
//       <div className="text-left">
//         <div className='flex justify-between'>



//           <h3 className="text-base font-bold text-[#020617] text-left">
//             {isViewMode ? "View campaign" : isUpdateMode ? "Edit campaign" : "Create campaign"}
//           </h3>


//           <TooltipProvider>
//             <Tooltip>
//               <TooltipTrigger asChild>
//                 <div className="flex items-center gap-2">
//                   <div>
//                     <Switch
//                       checked={isTestMode}
//                       onCheckedChange={setIsTestMode}
//                       className="bg-black-200"
//                       disabled={isTestModeDisabled || isViewMode || isUpdateMode}
//                     />
//                   </div>
//                   <span className={`text-xs font-medium px-2 py-0.5 rounded-full border ${isTestMode
//                     ? "bg-black-100 text-yellow-700 border-yellow-400"
//                     : "bg-black-100 text-white-500 border-gray-300"
//                     }`}>
//                     Test Mode
//                   </span>
//                 </div>
//               </TooltipTrigger>
//               <TooltipContent side="bottom" className="bg-black text-white border-black">
//                 <p>{isTestModeDisabled
//                   ? "Test Mode is only available for WhatsApp campaigns"
//                   : "Use this feature to test your template. Once satisfied, switch to Live mode"
//                 }</p>
//               </TooltipContent>
//             </Tooltip>
//           </TooltipProvider>
//         </div>

//         {/* Campaign Name Input */}
//         <div className="mt-4">
//           <Label htmlFor="campaignName" className="font-medium text-[#020617]" style={{ fontSize: '14px' }}>
//             Campaign name
//           </Label>
//           <Input
//             id="campaignName"
//             type="text"
//             placeholder="New campaign - 01/01/2025, 10:00 AM"
//             value={campaignName}
//             onChange={(e) => {
//               const val = e.target.value;
//               setCampaignName(val);
//               validateCampaignName(val);
//               validateDraftName(val, draftNames);
//             }}
//             className="mt-1 text-black placeholder-[#64748B] text-sm font-normal"
//             disabled={isUpdateMode || isViewMode}
//           />
//           {isSubmitAttempted && campaignNameError && (
//             <p className="text-red-500 text-xs mt-1 font-sans italic ml-1 text-left">
//               {campaignNameError}
//             </p>
//           )}

//           {isDraftSubmitAttempted && draftNameError && (
//             <p className="text-red-500 text-xs mt-1 font-sans italic ml-1 text-left">
//               {draftNameError}
//             </p>
//           )}
//         </div>

//         {/* From Country Multi-select */}
//         <div className="mt-4">
//           <Label htmlFor="fromCountry" className="font-medium text-[#020617]" style={{ fontSize: '14px' }}>
//             Reach people From
//           </Label>
//           {isLoadingCountries ? (
//             <div className="mt-1 h-10 border border-gray-300 rounded flex items-center justify-between px-3">
//               <span className="text-sm text-gray-500">Loading from countries...</span>
//               <CircularProgress size={16} />
//             </div>
//           ) : (
//             <MultiSelectFromCountry
//               options={updateCampaignId ? readonlyFromCountryOptions : FromCountryOptions}
//               selectedValues={fromCountries}
//               setSelectedValues={setFromCountries}
//               disabled={isUpdateMode || isViewMode}
//               onValueChange={(selected) => {
//                 setFromCountries(selected);
//                 updateSelectedISOs(selected);
//                 validateFromCountry(selected);
//                 handleFromCountryChange(selected);
//               }}
//               placeholder="Select country"
//               className="mt-1 text-black placeholder-[#64748B] text-sm font-normal"
//             />
//           )}

//           {isSubmitAttempted && fromCountryError && (
//             <p className="text-red-500 text-xs mt-1 font-sans italic ml-1 text-left">
//               {fromCountryError}
//             </p>
//           )}
//         </div>

//         {/* To Country Single-select */}
//         <div className="mt-4">
//           <Label htmlFor="toCountry" className="font-medium text-[#020617]" style={{ fontSize: '14px' }}>
//             Reach people Travelling to
//           </Label>
//           <div className="relative">
//             {((isUpdateMode || isViewMode) && (!targetCountriesLoaded || !toCountry)) ? (
//               <div className="mt-1 h-10 border border-gray-300 rounded flex items-center justify-between px-3">
//                 <span className="text-sm text-gray-500">Loading destination countries...</span>
//                 <CircularProgress size={16} />
//               </div>
//             ) : (
//               <SingleSelectToCountry
//                 options={updateCampaignId ? updateModeToCountryOptions : filteredToCountryOptions}
//                 selectedValue={toCountry}
//                 setSelectedValue={setToCountry}
//                 disabled={isUpdateMode || isViewMode}
//                 onValueChange={(selected) => {
//                   setToCountry(selected);
//                   updateSelectedToCountry(selected);
//                   validateToCountry(selected);
//                   GetAvailableCountries();
//                 }}
//                 placeholder="Select country"
//                 className="mt-1 text-black placeholder-[#64748B] text-sm font-normal"
//               />
//             )}
//           </div>
//           {isSubmitAttempted && toCountryError && (
//             <p className="text-red-500 text-xs mt-1 font-sans italic ml-1 text-left">
//               {toCountryError}
//             </p>
//           )}
//         </div>
//       </div>
//     </Card>
//   );
// };

// export default CampaignNameCard;


import React, { useEffect, useState } from 'react';
import { Card } from '../../../../Components/ui/card';
import { Label } from '../../../../Components/ui/label';
import { Input } from '../../../../Components/ui/input';
import { MultiSelectFromCountry } from '../../../../Components/ui/multi-select-from-country';
import { SingleSelectToCountry } from '../../../../Components/ui/single-select-to-country';
import { useCampaignContext } from '../CampaignContext';
import axios from 'axios';
import { RootState } from '@/src/State/store';
import { useDispatch, useSelector } from 'react-redux';
import { useCampaignValidators } from "../hooks/useCampaignValidators";
import { CircularProgress } from "@mui/material";
import { setSelectedFromCountryISOs } from "../../../../State/slices/AdvertiserAccountSlice";
import { Switch } from "../../../../Components/ui/switch";
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from "../../../../Components/ui/tooltip";
import { Info } from "lucide-react";

interface Country {
  country_name: string;
  country_code: string;
  country_iso: string;
}

const CampaignNameCard: React.FC = () => {
  const {
    campaignName,
    setCampaignName,
    fromCountries,
    setFromCountries,
    toCountry,
    setToCountry,
    setFromCountryOptions,
    FromCountryOptions,
    setToCountryOptions,
    ToCountryOptions,
    setFromCountryISOs,
    setFromCountryCodeMap,
    setToCountryISOs,
    setToCountryCodeMap,
    setSelectedFromCountryCodes,
    setSelectedToCountryISO,
    setSelectedToCountryCode,
    setWhatsappCountries,
    setSmsCountries,
    setChannelOptions,
    campaignNameError,
    fromCountryError,
    toCountryError,
    isSubmitAttempted,
    toCountryISOs,
    fromCountryISOs,
    toCountryCodeMap,
    fromCountryCodeMap,
    updateCampaignId,
    setCountries,
    countries,
    setReadonlyFromCountries,
    fromCountryISOsFromAPI,
    setReadonlyFromCountryOptions,
    readonlyFromCountryOptions,
    setTargetCountries,
    toCountryISOFromAPI,
    targetCountries,
    setUpdateModeToCountryOptions,
    updateModeToCountryOptions,
    isUpdateMode,
    whatsappData,
    smsData,
    setWhatsappData,
    setSmsData,
    selectedChannels,
    setSelectedChannels,
    whatsappCountries,
    smsCountries,
    setLoading,
    isLoading,
    setCampaignNames,
    isViewMode,
    draftNameError,
    draftNames,
    isDraftSubmitAttempted,
    isTestMode,
    setIsTestMode
  } = useCampaignContext();

  const selectedFromCountryISOs = useSelector((state: RootState) => state.advertiserAccount.selectedFromCountryISOs);
  const dispatch = useDispatch();

  // ✅ Add loading states
  const [isLoadingCountries, setIsLoadingCountries] = useState(false);
  const [countriesLoaded, setCountriesLoaded] = useState(false);
  const [targetCountriesLoaded, setTargetCountriesLoaded] = useState(false);

  const { validateCampaignName, validateFromCountry, validateToCountry, clearValidationErrors, validateDraftName } = useCampaignValidators();
  const apiUrlAdvAcc = useSelector((state: RootState) => state.authentication.apiURL);
  const workspaceId = useSelector((state: RootState) => state.authentication.workspace_id);


  // Updates selected ISO + code list based on selected country names
  const updateSelectedISOs = (countryNames: string[]) => {
    const isoList = countryNames.map(name => fromCountryISOs[name]).filter(Boolean);
    const codeList = isoList.map(iso => fromCountryCodeMap[iso]).filter(Boolean);

    dispatch(setSelectedFromCountryISOs(isoList));
    setSelectedFromCountryCodes(codeList);
  };

  // Updates To Country ISO and code based on name
  const updateSelectedToCountry = (name: string | null) => {
    if (!name) {
      setSelectedToCountryISO(null);
      setSelectedToCountryCode(null);
      return;
    }

    const iso = toCountryISOs[name];
    const code = iso ? toCountryCodeMap[iso] : null;

    setSelectedToCountryISO(iso || null);
    setSelectedToCountryCode(code || null);
  };

  // Smart cleanup function for when fromCountries change
  const handleFromCountryChange = (selectedCountries: string[]) => {
    if (selectedCountries.length === 0) {
      setWhatsappCountries([]);
      setSmsCountries([]);
      setChannelOptions([]);
      setWhatsappData([]);
      setSmsData([]);
      setSelectedChannels([]);
      clearValidationErrors?.('whatsapp');
      clearValidationErrors?.('sms');
      return;
    }

    const currentWhatsappCountryNames = whatsappCountries.map(c => c.name);
    const currentSmsCountryNames = smsCountries.map(c => c.name);

    const whatsappCountriesToRemove = currentWhatsappCountryNames.filter(
      countryName => !selectedCountries.some(selectedCountry => {
        const whatsappCountryObj = whatsappCountries.find(wc => wc.name === countryName);
        if (!whatsappCountryObj) return false;

        const fromCountryISO = fromCountryISOs[selectedCountry];
        return whatsappCountryObj.iso === fromCountryISO ||
          countries.some(c => c.country_name === selectedCountry && c.country_iso === whatsappCountryObj.iso);
      })
    );

    const smsCountriesToRemove = currentSmsCountryNames.filter(
      countryName => !selectedCountries.some(selectedCountry => {
        const smsCountryObj = smsCountries.find(sc => sc.name === countryName);
        if (!smsCountryObj) return false;

        const fromCountryISO = fromCountryISOs[selectedCountry];
        return smsCountryObj.iso === fromCountryISO ||
          countries.some(c => c.country_name === selectedCountry && c.country_iso === smsCountryObj.iso);
      })
    );

    if (whatsappCountriesToRemove.length > 0) {
      setWhatsappCountries(prev =>
        prev.filter(country => !whatsappCountriesToRemove.includes(country.name))
      );
      setWhatsappData(prev =>
        prev.filter(data => !whatsappCountriesToRemove.includes(data.country))
      );
      whatsappCountriesToRemove.forEach((_, index) => {
        clearValidationErrors?.('whatsapp', index);
      });
    }

    if (smsCountriesToRemove.length > 0) {
      setSmsCountries(prev =>
        prev.filter(country => !smsCountriesToRemove.includes(country.name))
      );
      setSmsData(prev =>
        prev.filter(data => !smsCountriesToRemove.includes(data.country))
      );
      smsCountriesToRemove.forEach((_, index) => {
        clearValidationErrors?.('sms', index);
      });
    }

    const remainingWhatsappCountries = whatsappCountries.filter(
      country => !whatsappCountriesToRemove.includes(country.name)
    );
    const remainingSmsCountries = smsCountries.filter(
      country => !smsCountriesToRemove.includes(country.name)
    );

    const newChannelOptions: { label: string; value: string }[] = [];
    const newSelectedChannels: string[] = [];

    if (remainingWhatsappCountries.length > 0) {
      newChannelOptions.push({ label: "WhatsApp", value: "whatsapp" });
      if (selectedChannels.includes("whatsapp")) {
        newSelectedChannels.push("whatsapp");
      }
    }

    if (remainingSmsCountries.length > 0) {
      newChannelOptions.push({ label: "SMS", value: "sms" });
      if (selectedChannels.includes("sms")) {
        newSelectedChannels.push("sms");
      }
    }

    setChannelOptions(newChannelOptions);
    setSelectedChannels(newSelectedChannels);
  };

  // ✅ Enhanced GetFromCountries with loading state
  const GetFromCountries = async () => {
    setIsLoadingCountries(true);
    try {
      const response = await axios.get(`${apiUrlAdvAcc}/GetFromCountries`);
      if (response.data?.status === "Success" && Array.isArray(response.data.fromCountries)) {
        const countries = response.data.fromCountries as Country[];
        setCountries(countries);

        const dropdownOptions = countries.map((c) => ({
          label: c.country_name,
          value: c.country_name,
        }));

        const isoMap = countries.reduce<{ [name: string]: string }>((acc, c) => {
          acc[c.country_name] = c.country_iso;
          return acc;
        }, {});

        const codeMap = countries.reduce<{ [iso: string]: string }>((acc, c) => {
          acc[c.country_iso] = c.country_code;
          return acc;
        }, {});

        setFromCountryOptions(dropdownOptions);
        setFromCountryISOs(isoMap);
        setFromCountryCodeMap(codeMap);
        setCountriesLoaded(true);
      }
    } catch (err) {
      console.error("Error fetching from countries:", err);
    } finally {
      setIsLoadingCountries(false);
    }
  };

  // ✅ Enhanced GetToCountries with loading state
  const GetToCountries = async () => {
    try {
      const response = await axios.get(`${apiUrlAdvAcc}/GetToCountries`);
      if (response.data?.status === "Success" && Array.isArray(response.data.toCountries)) {
        const countries = response.data.toCountries as Country[];
        setTargetCountries(countries);

        const dropdownOptions = countries.map((c) => ({
          label: c.country_name,
          value: c.country_name,
        }));

        const isoMap = countries.reduce<{ [name: string]: string }>((acc, c) => {
          acc[c.country_name] = c.country_iso;
          return acc;
        }, {});

        const codeMap = countries.reduce<{ [iso: string]: string }>((acc, c) => {
          acc[c.country_iso] = c.country_code;
          return acc;
        }, {});

        setToCountryOptions(dropdownOptions);
        setToCountryISOs(isoMap);
        setToCountryCodeMap(codeMap);
        setTargetCountriesLoaded(true);
      }
    } catch (err) {
      console.error("Error fetching to countries:", err);
    }
  };

  // Call API to get WhatsApp & SMS available countries using ISO list
  const GetAvailableCountries = async () => {
    try {
      const params = new URLSearchParams();
      selectedFromCountryISOs.forEach((iso: any) => params.append("isos", iso));

      const response = await axios.get(`${apiUrlAdvAcc}/GetAvailableWhatsappAndSmsCountries?${params.toString()}`);

      if (response.data?.status === "Success") {
        const countryResults = response.data.countries || [];
        const whatsappList: { name: string; iso: string }[] = [];
        const smsList: { name: string; iso: string }[] = [];
        const newChannelOptions: { label: string; value: string }[] = [];

        countryResults.forEach((entry: any) => {
          const { channel_id, channel_name, countries = [] } = entry;

          countries.forEach((country: { name: string; iso: string }) => {
            const obj = { name: country.name, iso: country.iso };
            if (channel_id === 1) whatsappList.push(obj);
            if (channel_id === 2) smsList.push(obj);
          });

          newChannelOptions.push({
            label: channel_name,
            value: channel_name.toLowerCase()
          });
        });

        setWhatsappCountries(whatsappList);
        setSmsCountries(smsList);
        setChannelOptions(newChannelOptions);
      }
    } catch (err) {
      console.error("Error fetching available countries:", err);
    }
  };

  const GetCampaignNames = async () => {
    try {
      const res = await axios.get(`${apiUrlAdvAcc}/GetAllCampaignNamesByWorkspaceID`, {
        params: { workspaceId: workspaceId },
      });

      if (res.data.status === "Success" && Array.isArray(res.data.campaignNames)) {
        const names = res.data.campaignNames;
        setCampaignNames(names.map((name: string) => name.toLowerCase()));
      } else {
        setCampaignNames([]);
      }
    } catch (err) {
      setCampaignNames([]);
    }
  };

  // ✅ Initial data loading
  useEffect(() => {
    GetFromCountries();
    GetToCountries();
    GetCampaignNames();
  }, []);

  // ✅ Trigger available countries when both from and to countries are set
  useEffect(() => {
    if (fromCountries && toCountry) {
      GetAvailableCountries();
    }
  }, [fromCountries, toCountry]);

  // ✅ CRITICAL FIX: Process update mode data only when countries are loaded
  useEffect(() => {
    if (!updateCampaignId || !countriesLoaded || !fromCountryISOsFromAPI?.length) {
      return;
    }

    console.log("🔄 Processing update mode countries - Countries loaded:", countriesLoaded);
    console.log("🔄 fromCountryISOsFromAPI:", fromCountryISOsFromAPI);

    const readonlyCountryNames: string[] = fromCountryISOsFromAPI
      .map((iso) => {
        const match = countries.find((c) => c.country_iso === iso);
        return match?.country_name;
      })
      .filter((name): name is string => typeof name === "string");

    console.log("🔄 Mapped country names:", readonlyCountryNames);

    if (readonlyCountryNames.length > 0) {
      setFromCountries(readonlyCountryNames);
      setReadonlyFromCountries(readonlyCountryNames);

      // Create readonly options for update mode
      const readonlyOptions = countries.map((country) => ({
        label: country.country_name,
        value: country.country_name,
        disabled: !readonlyCountryNames.includes(country.country_name),
      }));

      setReadonlyFromCountryOptions(readonlyOptions);

      // Update ISO mappings for the selected countries
      updateSelectedISOs(readonlyCountryNames);

      console.log("✅ Update mode countries set successfully");
    }
  }, [updateCampaignId, countriesLoaded, fromCountryISOsFromAPI, countries]);

  // ✅ Process update mode to country data
  useEffect(() => {
    if (!updateCampaignId || !toCountryISOFromAPI || !targetCountriesLoaded) {
      return;
    }

    const matched = targetCountries.find(
      (country) => country.country_iso === toCountryISOFromAPI
    );

    if (matched) {
      const selected = {
        label: matched.country_name,
        value: matched.country_name,
      };

      setToCountry(matched.country_name);
      setUpdateModeToCountryOptions([selected]);
      updateSelectedToCountry(matched.country_name);

      console.log("✅ Update mode to country set:", matched.country_name);
    }
  }, [updateCampaignId, toCountryISOFromAPI, targetCountriesLoaded, targetCountries]);

  // Filter ToCountry dropdown to exclude selected From countries
  const filteredToCountryOptions = ToCountryOptions.filter(
    (toOption) => !fromCountries.includes(toOption.value)
  );

  // ✅ Show loading state while countries are being loaded in update/view mode
  // if ((isUpdateMode || isViewMode) && (!countriesLoaded || !targetCountriesLoaded)) {
  //   return (
  //     <Card className="w-[600px] mt-[-10px] p-4 shadow-sm">
  //       <div className="text-left">
  //         <h3 className="text-base font-bold text-[#020617] text-left">
  //           {isViewMode ? "View campaign" : "Edit campaign"}
  //         </h3>
  //         <div className="flex justify-center items-center h-32">
  //           <CircularProgress size={24} />
  //           <span className="ml-2 text-sm text-gray-600">Loading campaign data...</span>
  //         </div>
  //       </div>
  //     </Card>
  //   );
  // }

  const isTestModeDisabled = selectedChannels.length > 0 && (
    !selectedChannels.includes("whatsapp") || selectedChannels.includes("sms")
  );


  useEffect(() => {
    if (isTestModeDisabled) {
      setIsTestMode(false);
    }
  }, [isTestModeDisabled]);


  return (
    <Card className="w-[600px] mt-[-10px] p-4 shadow-sm">
      <div className="text-left">
        <div className='flex justify-between'>



          <h3 className="text-base font-bold text-[#020617] text-left">
            {isViewMode ? "View campaign" : isUpdateMode ? "Edit campaign" : "Create campaign"}
          </h3>
          <div className="flex items-center gap-2">
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <div>
                    <Switch
                      checked={isTestMode}
                      onCheckedChange={setIsTestMode}
                      className="bg-black-200"
                      disabled={isTestModeDisabled || isViewMode || isUpdateMode}
                    />
                  </div>
                </TooltipTrigger>
                {isTestModeDisabled && (
                  <TooltipContent side="bottom" className="bg-black text-white border-black">
                    <p>Test Mode is only available for WhatsApp campaigns</p>
                  </TooltipContent>
                )}
              </Tooltip>
            </TooltipProvider>
            <span className={`text-xs font-medium px-2 py-0.5 rounded-full border ${isTestMode
              ? "bg-yellow-100 text-yellow-700 border-yellow-400"
              : "bg-gray-100 text-gray-500 border-gray-300"
              }`}>
              Test Mode
            </span>
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <span className="cursor-pointer">
                    <Info
                      className="w-4 h-4 cursor-pointer hover:opacity-80"
                      style={{ color: "#3A85F7" }}
                    />
                  </span>
                </TooltipTrigger>
                <TooltipContent side="bottom" className="bg-black text-white border-black">
                  <p>Use this feature to test your template. Once satisfied, switch to Live mode</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>
        </div>

        {/* Campaign Name Input */}
        <div className="mt-4">
          <Label htmlFor="campaignName" className="font-medium text-[#020617]" style={{ fontSize: '14px' }}>
            Campaign name
          </Label>
          <Input
            id="campaignName"
            type="text"
            placeholder="New campaign - 01/01/2025, 10:00 AM"
            value={campaignName}
            onChange={(e) => {
              const val = e.target.value;
              setCampaignName(val);
              validateCampaignName(val);
              validateDraftName(val, draftNames);
            }}
            className="mt-1 text-black placeholder-[#64748B] text-sm font-normal"
            disabled={isUpdateMode || isViewMode}
          />
          {isSubmitAttempted && campaignNameError && (
            <p className="text-red-500 text-xs mt-1 font-sans italic ml-1 text-left">
              {campaignNameError}
            </p>
          )}

          {isDraftSubmitAttempted && draftNameError && (
            <p className="text-red-500 text-xs mt-1 font-sans italic ml-1 text-left">
              {draftNameError}
            </p>
          )}
        </div>

        {/* From Country Multi-select */}
        <div className="mt-4">
          <Label htmlFor="fromCountry" className="font-medium text-[#020617]" style={{ fontSize: '14px' }}>
            Reach people From
          </Label>
          {isLoadingCountries ? (
            <div className="mt-1 h-10 border border-gray-300 rounded flex items-center justify-between px-3">
              <span className="text-sm text-gray-500">Loading from countries...</span>
              <CircularProgress size={16} />
            </div>
          ) : (
            <MultiSelectFromCountry
              options={updateCampaignId ? readonlyFromCountryOptions : FromCountryOptions}
              selectedValues={fromCountries}
              setSelectedValues={setFromCountries}
              disabled={isUpdateMode || isViewMode}
              onValueChange={(selected) => {
                setFromCountries(selected);
                updateSelectedISOs(selected);
                validateFromCountry(selected);
                handleFromCountryChange(selected);
              }}
              placeholder="Select country"
              className="mt-1 text-black placeholder-[#64748B] text-sm font-normal"
            />
          )}

          {isSubmitAttempted && fromCountryError && (
            <p className="text-red-500 text-xs mt-1 font-sans italic ml-1 text-left">
              {fromCountryError}
            </p>
          )}
        </div>

        {/* To Country Single-select */}
        <div className="mt-4">
          <Label htmlFor="toCountry" className="font-medium text-[#020617]" style={{ fontSize: '14px' }}>
            Reach people Travelling to
          </Label>
          <div className="relative">
            {((isUpdateMode || isViewMode) && (!targetCountriesLoaded || !toCountry)) ? (
              <div className="mt-1 h-10 border border-gray-300 rounded flex items-center justify-between px-3">
                <span className="text-sm text-gray-500">Loading destination countries...</span>
                <CircularProgress size={16} />
              </div>
            ) : (
              <SingleSelectToCountry
                options={updateCampaignId ? updateModeToCountryOptions : filteredToCountryOptions}
                selectedValue={toCountry}
                setSelectedValue={setToCountry}
                disabled={isUpdateMode || isViewMode}
                onValueChange={(selected) => {
                  setToCountry(selected);
                  updateSelectedToCountry(selected);
                  validateToCountry(selected);
                  GetAvailableCountries();
                }}
                placeholder="Select country"
                className="mt-1 text-black placeholder-[#64748B] text-sm font-normal"
              />
            )}
          </div>
          {isSubmitAttempted && toCountryError && (
            <p className="text-red-500 text-xs mt-1 font-sans italic ml-1 text-left">
              {toCountryError}
            </p>
          )}
        </div>
      </div>
    </Card>
  );
};

export default CampaignNameCard;